// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  viewId: __t.u64().primaryKey().name("view_id"),
  identity: __t.identity(),
  sigKey: __t.string().name("sig_key"),
  systemId: __t.string().name("system_id"),
  epoch: __t.u32(),
  kind: __t.string(),
  stage: __t.string(),
  state: __t.string(),
  stock: __t.u32(),
  hazard: __t.u8(),
  collapseAt: __t.u8().name("collapse_at"),
  band: __t.string(),
  knownAt: __t.timestamp().name("known_at"),
  source: __t.string(),
  leasedBy: __t.string().name("leased_by"),
  leaseExpiresAt: __t.timestamp().name("lease_expires_at"),
  recoverUntil: __t.timestamp().name("recover_until"),
  workMode: __t.string().name("work_mode"),
  workMs: __t.u32().name("work_ms"),
  workNeedMs: __t.u32().name("work_need_ms"),
  lastBeatAt: __t.timestamp().name("last_beat_at"),
  stepSeq: __t.u32().name("step_seq"),
  firstByMe: __t.bool().name("first_by_me"),
  updatedAt: __t.timestamp().name("updated_at"),
});
